import React from 'react';
import PropTypes from 'prop-types';
import { Button, ListGroup, Spinner } from 'react-bootstrap';

function IntegrationsList({
  title,
  onClick = null,
  integrations = [],
  loading = false,
  active,
  level,
  setActive = null,
}) {
  return (
    <>
      {title && <h5>{title}</h5>}
      {loading ? (
        <div className="text-center">
          <Spinner animation="grow" />
        </div>
      ) : (
        <ListGroup>
          {integrations.length > 0 ? (
            integrations.map((integration) => {
              const { name } = integration;
              const isActive = name === active;
              return (
                <ListGroup.Item
                  key={name}
                  onClick={() => onClick && onClick(integration)}
                  variant="light"
                  className="d-flex align-items-center pointer justify-content-between"
                >
                  <code className="mr-auto">{name}</code>
                  {integration.level && level !== integration.level && (
                    <span className="mr-lg-3 mr-md-3 mr-1">
                      {integration.level}
                      {integration.level === 'Company'
                        ? ''
                        : ` ID: ${integration.level_id}`}
                    </span>
                  )}
                  <div onClick={(e) => e.stopPropagation()}>
                    <Button
                      size="sm"
                      style={{
                        cursor: !isActive ? 'pointer' : 'initial',
                        minWidth: '9ch',
                      }}
                      disabled={isActive}
                      onClick={() =>
                        !isActive && setActive && setActive(integration)
                      }
                      variant={active === name ? 'success' : 'primary'}
                    >
                      {isActive ? 'Current' : 'Select'}
                    </Button>
                  </div>
                </ListGroup.Item>
              );
            })
          ) : (
            <ListGroup.Item>No integrations</ListGroup.Item>
          )}
        </ListGroup>
      )}
    </>
  );
}

IntegrationsList.propTypes = {
  title: PropTypes.string,
  integrations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  active: PropTypes.string,
  setActive: PropTypes.func,
};

export default IntegrationsList;
